module.exports = __webpack_public_path__ + "static/media/HCMM314.88ce0b5d.jpg";